<script>
import {mapState,mapMutations} from 'vuex'

import ModalCloseButton from "@/components/core/ModalCloseButton.vue";
import templatable from "@/mixins/templatable";
import BidPlacedMessage from "@/components/bid-created-modal/BidPlacedMessage.vue";
import YourBid from "@/components/bid-created-modal/YourBid.vue";
import {getIncrements} from "@/helpers";
import BidIncrement from "@/components/bid-created-modal/BidIncrement.vue";
import BidDate from "@/components/bid-created-modal/BidDate.vue";
import dynamicFieldsMixin from "@/mixins/dynamicFieldsMixin";

export default {
  name: "BidCreatedModal",
  components: {ModalCloseButton, BidPlacedMessage, YourBid, BidIncrement, BidDate},
  mixins: [templatable('bidCreatedModalTemplate'), dynamicFieldsMixin],
  data() {
    return {
      template: `
        <b-modal v-if="lot"
              :id="bidCreatedModal.id || 'bidCreatedModal'"
           v-model="bidCreatedModal.show"
           header-bg-variant="light"
           header-text-variant="dark"
           ok-only
           ok-variant="secondary"
           :ok-title="$t('Close')"
           static
           centered>
          <template #modal-header="{ close }">
            <h5 class="modal-title"
                v-html="$options.filters.stripTags($options.filters.currentLocale(lot.title))"></h5>
            <ModalCloseButton @click="closeModal()" />
          </template>
          [[template]]
        </b-modal>
      `
    }
  },
  computed: {
    ...mapState(['bidCreatedModal', 'customer']),
    ...mapState({
      lot: state => state.bidCreatedModal.lot,
      bid: state => state.bidCreatedModal.bid,
    }),
    increments() {
      return getIncrements(this.lot)
    },
    nextIncrement() {
      const increment = this.increments[0];
      return increment?.increment
    }
  },
  methods: {
    ...mapMutations(['hideBidCreatedModal']),
    closeModal() {
      this.hideBidCreatedModal()
    },
  }
}
</script>

<style lang="scss">
  @import "../bootstrap/import";

  .ta-bid-created-modal-data {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 0;
    border-bottom: 1px solid $gray-200;
  }
</style>
